var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"value":_vm.showTooltip,"content":"コピーしました","manual":""}},[_c('el-button',{attrs:{"disabled":_vm.disabled,"icon":"el-icon-document"},on:{"click":_vm.handleClick}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }